"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ordersError = exports.receiveOrders = exports.receiveOrdersStarted = exports.ORDERS_ERROR = exports.RECEIVE_ORDERS = exports.RECEIVE_ORDERS_STARTED = void 0;
exports.default = reducer;
exports.loadOrders = loadOrders;
const api_1 = require("core/api");
// Actions
exports.RECEIVE_ORDERS_STARTED = 'RECEIVE ORDERS STARTED';
exports.RECEIVE_ORDERS = 'RECIEVE ORDERS';
exports.ORDERS_ERROR = 'ORDERS ERROR';
// Reducer
const initialState = {
    orders: [],
    ordersLoaded: false,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reducer(state = initialState, action = {}) {
    const orders = action.data;
    switch (action.type) {
        case exports.RECEIVE_ORDERS_STARTED:
            return {
                ...state,
            };
        case exports.RECEIVE_ORDERS:
            return {
                ...state,
                ordersLoaded: true,
                orders: orders,
            };
        case exports.ORDERS_ERROR:
            return {
                ...state,
                ordersLoaded: false,
                error: action.error,
            };
        default:
            return state;
    }
}
// Action Creators
const receiveOrdersStarted = () => {
    return { type: exports.RECEIVE_ORDERS_STARTED };
};
exports.receiveOrdersStarted = receiveOrdersStarted;
const receiveOrders = (data) => {
    return { type: exports.RECEIVE_ORDERS, data };
};
exports.receiveOrders = receiveOrders;
const ordersError = (data) => {
    return { type: exports.ORDERS_ERROR, data };
};
exports.ordersError = ordersError;
// Services
function loadOrders() {
    return (dispatch) => {
        dispatch((0, exports.receiveOrdersStarted)());
        return api_1.OrdersService.getOrders()
            .then((res) => {
            dispatch((0, exports.receiveOrders)(res));
        })
            .catch((error) => {
            dispatch((0, exports.ordersError)(error));
        });
    };
}
